module.exports = __webpack_public_path__ + "static/media/3228336_silo_icon.accc6a61.ico";